
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import ProgramProfile from '@/components/programs/ProgramProfile.vue';
import AllPrograms from '@/components/programs/AllPrograms.vue';
import AddProgram from '@/components/programs/AddProgram.vue';

import userx from '@/store/modules/userx';
import programx from '@/store/modules/programx';

import { SoftwareType, ProgramData } from '@/store/models.def';

@Component({
	components: {
		ProgramProfile,
		AllPrograms,
		AddProgram,
	},
})
export default class ProgramManager extends Vue {
	public get groupedPrograms() {
		return programx.groupedPrograms;
	}
	public currentProgram: ProgramData | null = null;
}
